// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"point-progress-bar_progress-bar__2kRKJ","circle":"point-progress-bar_circle__3jhFk","filled":"point-progress-bar_filled__3A_ls"};